
export const SET_ITEMS = "setItems";
export const GET_ITEMS = "getItems";
export const SET_TRANSACTION_AMOUNT = "setTransactionAmount";
export const GET_TRANSACTION_AMOUNT = "getTransactionAmount";
export const SET_TRANSACTION_AMOUNT_IMMUTABLE = "setTransactionAmountImmutable"
export const GET_TRANSACTION_AMOUNT_IMMUTABLE = "getTransactionAmountImmutable"
export const SET_AUCTION_ID = 'setAuctionId';
export const GET_AUCTION_ID = 'getAuctionId';
export const LOADING = 'loading';

export const INVALIDATE_BUTTON_SUBMIT = 'invalidateSubmitButton'
export const EXTERNAL_REFERENCE = 'externalReference';

//parametros mercado pago cartão de credito
export const SET_AUCTIONEER_ID = 'setAuctioneerId';
export const GET_AUCTIONEER_ID = 'getAuctioneerId';
export const ISSUER = 'issuer'
export const SET_LENGTH_CVV = "setLengthCvv";
export const GET_LENGTH_CVV = "getLengthCvv";
export const GET_INSTALLMENTS = 'installments';
export const SET_INSTALLMENTS = 'setInstallments';
export const SET_CARDHOLDER_NAME = "setCardHolderName";
export const SET_PAYER = "setPayer";
export const GET_PAYER = "getPayer";
export const SET_ERROR_FIELDS = 'setErrorField';
export const GET_ERROR_FIELDS = 'getErrorField';
export const SET_ERROR = "setError";
export const GET_ERROR = "getError";
export const SUBMIT = 'triggerSubmit';
export const SUBMIT_FORM_CREDIT_CARD = 'triggerSubmitCreditCardForm';
export const  SUBMIT_PIX = 'submitPix';

export const RESPONSE = 'response';
